import { NavLink } from 'react-router-dom';

import { Translate } from '../../helpers/Translate';
// Reuses the quick-access tile styles from the Home page
import "./parentpages/Home/Home.css";
import wallet from "./parentpages/Home/assets/img/wallet.png";
import installmentsicon from "./parentpages/Home/assets/img/installments.jpg";
import serviceicon from "./parentpages/Home/assets/img/servicesubscription.jpg";

const t = new Translate();

// Finance sections, in display order
const tiles = [
  { to: "/dashboard/finance/schoolfees", image: installmentsicon, title: "School Installments" },
  { to: "/dashboard/finance/ewallet", image: wallet, title: "Cafeteria" },
  { to: "/dashboard/finance/servicesubscription", image: serviceicon, title: "Service subscriptions" },
];

/**
 * Smart Wallet landing page: links to school installments, the cafeteria
 * e-wallet and service subscriptions.
 */
const Finance = () => {
  return (
    <div className="content">
      <div className="pp-home-tiles">
        {tiles.map((tile) => (
          <NavLink key={tile.to} className="pp-home-tile" to={tile.to}>
            <div className="pp-home-tile-media">
              <img src={tile.image} alt="" />
            </div>
            <h2 className="pp-home-tile-title">{t.translate(tile.title)}</h2>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Finance;
